import { render, staticRenderFns } from "./ParticaRightDrawer.vue?vue&type=template&id=6ef0c984&"
import script from "./ParticaRightDrawer.vue?vue&type=script&lang=ts&"
export * from "./ParticaRightDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports